import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import styled from "styled-components";
import { useApp } from "../../contexts";
import { useWindowSize } from "../../hook/useWindowSize";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const COLOR1 = "#999CED";
const COLOR2 = "#F12E11";

const LegendItem = styled.div`
  flex: 1;
  color: #fcddec;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  @media screen and (max-width: 1024px) {
    font-size: 10px;
  }
`;

const PrefixLegendItem = styled.div`
  width: 12px;
  height: 12px;
  background-color: ${(props) => props.color};
  border-radius: 100%;
`;

function BarChartAffiliate({ dataChart }) {
  const { T } = useApp();
  const size = useWindowSize();
  const data = {
    labels: dataChart?.dataLabel?.map(item => {
      return T(item);
    }),
    datasets: [
      {
        label: T("Commission"),
        data: dataChart?.dataCommission,
        backgroundColor: COLOR1,
        borderRadius: Number.MAX_VALUE,
        borderSkipped: false,
        barThickness: 24,
        maxBarThickness: 20,
      },
      {
        label: T("Referral Buyers"),
        data: dataChart?.dataLRefer,
        backgroundColor: COLOR2,
        borderRadius: Number.MAX_VALUE,
        borderSkipped: false,
        barThickness: 24,
        maxBarThickness: 20,
      },
    ],
  };
  const options = {
    // responsive: true,
    aspectRatio: size.width < 576 ? 1.5 : 1.8,
    plugins: {
      legend: {
        display: false,
        padding: 10,
        position: "top",
        align: "start",
        labels: {
          padding: 20,
          color: "#FCDDEC",
          boxWidth: 10,
          boxHeight: 10,
          usePointStyle: true,
          font: {
            size: 12,
          },
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        border: {
          color: "#fff",
          width: 3,
        },
        grid: {
          display: false,
          drawTicks: false,
          drawBorder: false,
        },
        ticks: {
          padding: 10,
          color: "#fff",
        },
      },
      y: {
        beginAtZero: true,
        border: {
          display: false,
          dash: [6],
        },
        grid: {
          display: true,
          drawTicks: false,
          drawBorder: false,
          color: "#fff",
          lineWidth: 2,
        },
        ticks: {
          padding: 20,
          color: "#fff",
          // callback: function (val, index) {
          //   const valString = val.toString();
          //   if(valString.)
          //   return val;
          // },
        },
      },
    },
  };

  return (
    <div style={{ width: "100%" }}>
      <div className="flex justify-center lg:justify-start gap-4 px-[20px]">
        <div className="flex items-center gap-2">
          <PrefixLegendItem color={COLOR1} />
          <LegendItem>{T("Commission")}</LegendItem>
        </div>
        <div className="flex items-center gap-2">
          <PrefixLegendItem color={COLOR2} />
          <LegendItem>{T("Referral Buyers")}</LegendItem>
        </div>
      </div>
      <Bar options={options} data={data} />
    </div>
  );
}

export default BarChartAffiliate;
